import React from "react";
import PropTypes from "prop-types";
import "../css/App.scss";
import {logout, uploadCandidateFile} from "../../services/PostService";
import {sprintf} from "sprintf-js";
import {deleteCandidateFile} from "../../services/DeleteService";
import {removeItemFromSessionStorage} from "../../services/CacheService";
import Modal from "react-bootstrap/Modal";

export default class ProfileButtons extends React.PureComponent {

	static propTypes = {
		positionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		language: PropTypes.string,
		customerName: PropTypes.string.isRequired,
	};

	openLogoutModal = () =>{
		this.setState({showLogoutModal: true})
}


	handleLogout = () => {
		this.openLogoutModal();
}

	logout = () => {
		logout(sessionStorage.getItem('userId-'+ this.props.customerName ), sessionStorage.getItem('apiKey-' + this.props.customerName)).then(() => {
			sessionStorage.clear();
			window.location = '/' + this.props.language + '/gate/' + this.props.customerName + '/positions';
		});
	};

	maxLength = 20;
	maxSizeMb = 10;
	maxSize = this.maxSizeMb * 1024 * 1024;

	constructor(props){
		super(props);
		this.state = {
			loading: false,
			files: JSON.parse(sessionStorage.getItem('files-'+sessionStorage.getItem('userId-' + this.props.customerName))) || [],
			showModal: false,
			showLogoutModal: false
		};
	};

	uploadCandidateFile = (event) => {
		let {files} = this.state;
		let file = event.target.files[0];

		if (!file) {
			return;
		}

		if (files.length >= this.maxLength) {
			return;
		}

		if (file.size > this.maxSize) {
			this.setState({
				showModal: true,
				modalTitle: window.Translator.getSlug('Error', this.props.language),
				modalBody: sprintf(window.Translator.getSlug('MaxFileSize%sMbExceeded', this.props.language), this.maxSizeMb)
			});
			return;
		}
			uploadCandidateFile(file, this.props.customerName)
				.then(response =>  response.json())
				.then(json => {
					if(json.success){
						files.unshift({name: file.name, identificator: json.id, mongoId: json.mongoId, class: 'fa-times'});
						sessionStorage.setItem('files-'+sessionStorage.getItem('userId-' + this.props.customerName), JSON.stringify(files));
						this.setState({files:files});
					} else {
						this.setState({
							showModal: true,
							modalTitle: window.Translator.getSlug('Error', this.props.language),
							modalBody: json.reason ? window.Translator.getSlug(json.reason, this.props.language): null
						});
					}
					this.forceUpdate()
				}).catch(error=> {
				console.log(error);
			});
	};

	renderUploadedFiles = () => {
		return this.state['files'].map(file => {
			return (
				<li key={file.identificator} className={' padding-bottom-3'}>
					<label style={{'color': '#6f7484'}}>{file.name}</label>
					<i className={'fa del-button fa-trash ' + file.class}
					   onClick={() => this.deleteFile(file.identificator)} style={{'color': '#aaa'}}
					/>
				</li>
			);
		});
	};

	deleteFile(id){
		this.changeFileClass(id);
			deleteCandidateFile(id, this.props.customerName)
				.then( response => response.json())
				.then(json => {
					if(!json.success) {
						this.changeFileClass(id);
					}else{
						let userId = sessionStorage.getItem('userId-' + this.props.customerName);
						removeItemFromSessionStorage(id, 'files-'+userId);
						this.setState({files: JSON.parse(sessionStorage.getItem('files-'+userId)) || []});
					}
				})
				.catch(error => {
					this.changeFileClass(id);
					console.log(error);
				})
	}

	changeFileClass = (id) => {
		let file = this.state['files'].find(element => element.identificator === id);
		if (file!== undefined) {
			file.class = file.class === 'fa-times' ? 'fa-sync fa-spin' : 'fa-times';
		}
		this.forceUpdate();
	};

	closeModal = () => {
		this.setState({showModal: false});
	};

	closeLogoutModal = () =>{
	this.setState({showLogoutModal: false})}


	render(){
		return (
			<>
			<div className="profile-buttons card-deck">
				<Modal id="register-done" show={this.state.showLogoutModal} onHide={this.closeLogoutModal} animation={false}
					   dialogClassName={'smallDialog'}>
					<Modal.Body>
						<i className="fa fa-check-circle fa-3x"/>
						<h5>{window.Translator.getSlug('Done', this.props.language)}</h5>
						<p>{window.Translator.getSlug('ThankYouGoodLuck', this.props.language)}</p>
						<button onClick={this.logout}
								className={'btn btn-default'}>
							{window.Translator.getSlug('Close', this.props.language)}
							</button>
					</Modal.Body>
				</Modal>
				<Modal show={this.state['showModal']} onHide={this.closeLogoutModal} animation={false}
					   dialogClassName={'smallDialog'}>
					<Modal.Header closeButton>
						<Modal.Title>{this.state['modalTitle']}</Modal.Title>
					</Modal.Header>
					<Modal.Body>{this.state['modalBody']}</Modal.Body>
					<Modal.Footer>
						<button onClick={this.closeModal}
								className={'btn btn-default'}>
							{window.Translator.getSlug('Close', this.props.language)}
						</button>
					</Modal.Footer>
				</Modal>
				<a className={"card cursor-pointer"}>
					{this.state['files'].length >= this.maxLength ?
							<label className='text-center font-weight-bold mx-auto'>{sprintf(window.Translator.getSlug('MaxFileCount%sReached', this.props.language), this.maxLength)}</label>
						:
						( <>
					<input
						type="file"
						name="file"
						id="file"
						className="inputfile"
						onChange={this.uploadCandidateFile} />
							<h5 className={"card-title text-center"}>
						<label htmlFor="file" className="cursor-pointer">
							<i className={'fa fa-cloud-upload-alt fa-2x margin-right-10'} />
							 {window.Translator.getSlug('AddFiles', this.props.language)}
						</label>
					</h5>
							</> )
					}
				</a>
				<a className={"card cursor-pointer"}
				   href={'/' + this.props.language + '/gate/' + this.props.customerName + '/positions'}>
					<h5 className={"card-title text-center"}>
						<i className="fa fa-home fa-2x margin-right-10"/>
						{window.Translator.getSlug('OtherJobs', this.props.language)}
					</h5>
				</a>
				<a className={"card cursor-pointer"} role="button" onClick={this.handleLogout} href="#">
					<h5 className={"card-title text-center"}>
						<i className="fa fa-sign-out-alt fa-2x margin-right-10"/>
						{window.Translator.getSlug('Finish', this.props.language)}
					</h5>
				</a>
			</div>
		<div className={'row'}>
			<div className="uploaded-files">
				<div className="col-12">
					{this.state.files.length > 0 ? <h6>{window.Translator.getSlug('UploadedAttachments', this.props.language)}: </h6> : ''}
					<ul className={'no-list-style padding-left-0'}>
						{this.renderUploadedFiles()}
					</ul>
				</div>
			</div>
		</div>
				</>
		)
	}
}
